import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useDictionaryTranslation } from '../../hooks/useDictionaryTranslation';
import { servicePriorities } from '../../config/constants/servicePrioritiesConstants';

const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  padding: 2px 14px;
  border-radius: 15px;
  font-size: 12px;
  line-height: 20px;
  color: ${({ color }) => color};
  background-color: ${({ color }) => `${color}20`};
  border: 1px solid ${({ color }) => color};
`;

export const PriorityPill = ({ value }) => {
  const { translate: t } = useDictionaryTranslation();
  const priorityData = Object.values(servicePriorities).find((priority) => priority.value === value);
  if (!priorityData) return null;
  return <Pill color={priorityData.color}>{t(priorityData.label)}</Pill>;
};

PriorityPill.propTypes = {
  value: PropTypes.number,
};
